export function orderRequestSessionStorage() {
  const prefix = `orderRequest_${window.location.pathname}`;

  const setItem = (data) => {
    try {
      sessionStorage.setItem(`${prefix}_request`, JSON.stringify(data));
    } catch (e) {
      console.error(e);
    }
  };

  const getItem = (defaultVal = null) => {
    try {
      return JSON.parse(sessionStorage.getItem(`${prefix}_request`));
    } catch (e) {
      console.error(e);
      return defaultVal;
    }
  };

  const removeItem = () => {
    sessionStorage.removeItem(`${prefix}_request`);
  };

  return {
    setItem,
    getItem,
    removeItem
  };
}

export default orderRequestSessionStorage;
